import { render } from "./BottomLinks.vue?vue&type=template&id=0e1b068c&scoped=true"
import script from "./BottomLinks.vue?vue&type=script&lang=js"
export * from "./BottomLinks.vue?vue&type=script&lang=js"

import "./BottomLinks.vue?vue&type=style&index=0&id=0e1b068c&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1b068c"]])

export default __exports__